import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpErrorInterceptor } from '@shared/core/interceptors/http-error.interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { env } from 'process';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
    provideEnvironmentNgxMask(),
    { provide: 'googleTagManagerId', useValue: 'GTM-P5S32ZBD' },
  ],
};
